import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  tabIndex: number;
}

const initialState: States = {
  tabIndex: 0,
};

export const dataExportSlice = createSlice({
  initialState,
  name: 'dataExport',
  reducers: {
    setTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.tabIndex = payload;
    },
  },
});

export default dataExportSlice.reducer;

export const { setTabIndex: setTabIndexAction } = dataExportSlice.actions;
